import { FC, ReactElement } from 'react';
import { Modal } from 'react-bootstrap';
import i18next from 'i18next';
import TelerehabilitationProgramForm from './TelerehabilitationProgramForm';
import { TelerehabilitationProgramDto } from '../../../../../shared/dtos/telerehabilitationProgram.dto';
import AppModal from '../../../components/app-modal/AppModal';

type TelerehabilitationProgramModalProps = {
  show: boolean;
  telerehabilitationProgram: TelerehabilitationProgramDto | null;
  onClose: () => void;
  onSave: () => void;
}

const TelerehabilitationProgramModal: FC<TelerehabilitationProgramModalProps> = ({
  show,
  telerehabilitationProgram,
  onClose,
  onSave
}: TelerehabilitationProgramModalProps): ReactElement => {
  return (
    <AppModal size="lg" show={show} onHide={onClose} backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title>
          {i18next.t(telerehabilitationProgram ? 'telerehabilitationProgramModal.editTitle' : 'telerehabilitationProgramModal.createTitle')}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <TelerehabilitationProgramForm 
          data={telerehabilitationProgram} 
          onClose={onClose} 
          onSubmit={() => {
            onSave();
            onClose();
          }} 
        />
      </Modal.Body>
    </AppModal>
  );
};


export default TelerehabilitationProgramModal;
